import * as ActionTypes from './actionTypes';

const initialState = {
  performanceCharts: [],
  performanceStatics: null,
  performanceOverviews: null,
  performanceChartsLoading: true,
  performanceStaticsLoading: true,
  performanceOverviewsLoading: true,

  isLoadingGetInsightOverview: false,
  isLoadingGetRevenueDistributionOverview: false,
  isLoadingGetRevenueDistributionChart: false,

  insightOverview: {},
  revenuaDistributionOverview: {},
  revenuaDistributionChart: {},
};

export default function analytics(state = initialState, action) {
  switch (action.type) {
    // GET_PERFORMANCE_STATICS
    case ActionTypes.GET_PERFORMANCE_STATICS:
      return {
        ...state,
        performanceStaticsLoading: true,
      };
    case ActionTypes.GET_PERFORMANCE_STATICS_SUCCESS:
      return {
        ...state,
        performanceStaticsLoading: false,
        performanceStatics: action.payload,
      };
    case ActionTypes.GET_PERFORMANCE_STATICS_FAILURE:
      return {
        ...state,
        performanceStaticsLoading: false,
      };

    // GET_PERFORMANCE_OVERVIEWS
    case ActionTypes.GET_PERFORMANCE_OVERVIEWS:
      return {
        ...state,
        performanceOverviewsLoading: true,
      };
    case ActionTypes.GET_PERFORMANCE_OVERVIEWS_SUCCESS:
      return {
        ...state,
        performanceOverviewsLoading: false,
        performanceOverviews: action.payload,
      };
    case ActionTypes.GET_PERFORMANCE_OVERVIEWS_FAILED:
      return {
        ...state,
        performanceOverviewsLoading: false,
      };

    // GET_PERFORMANCE_CHARTS
    case ActionTypes.GET_PERFORMANCE_CHARTS:
      return {
        ...state,
        performanceChartsLoading: true,
      };

    case ActionTypes.GET_PERFORMANCE_CHARTS_SUCCESS:
      return {
        ...state,
        performanceChartsLoading: false,
        performanceCharts: action.payload,
      };

    case ActionTypes.GET_PERFORMANCE_CHARTS_FAILED:
      return {
        ...state,
        performanceChartsLoading: false,
      };

    // GET_INSIGHT_OVERVIEW
    case ActionTypes.GET_INSIGHT_OVERVIEW:
      return {
        ...state,
        isLoadingGetInsightOverview: true,
      };

    case ActionTypes.GET_INSIGHT_OVERVIEW_SUCCESS:
      return {
        ...state,
        isLoadingGetInsightOverview: false,
        insightOverview: action.payload,
      };

    case ActionTypes.GET_INSIGHT_OVERVIEW_FAILED:
      return {
        ...state,
        isLoadingGetInsightOverview: false,
      };

    // GET REVENUE DISTRIBUTION OVERVIEW
    case ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW:
      return {
        ...state,
        isLoadingGetRevenueDistributionOverview: true,
      };

    case ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW_SUCCESS:
      return {
        ...state,
        isLoadingGetRevenueDistributionOverview: false,
        revenuaDistributionOverview: action.payload,
      };

    case ActionTypes.GET_REVENUE_DISTRIBUTION_OVERVIEW_FAILED:
      return {
        ...state,
        isLoadingGetRevenueDistributionOverview: false,
      };

    // GET REVENUE DISTRIBUTION CHART
    case ActionTypes.GET_REVENUE_DISTRIBUTION_CHART:
      return {
        ...state,
        isLoadingGetRevenueDistributionChart: true,
      };

    case ActionTypes.GET_REVENUE_DISTRIBUTION_CHART_SUCCESS:
      return {
        ...state,
        isLoadingGetRevenueDistributionChart: false,
        revenuaDistributionChart: action.payload,
      };

    case ActionTypes.GET_REVENUE_DISTRIBUTION_CHART_FAILED:
      return {
        ...state,
        isLoadingGetRevenueDistributionChart: false,
      };

    default:
      return state;
  }
}
